import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/user/accountEmail/user.accountEmail.mutation.gql"
import type {
  UserAccountEmailMutation,
  UserAccountEmailMutationVariables,
} from "@/v2-backoffice-client/user/accountEmail/__types__/user.accountEmail.mutation"

type Options = MutationHookOptions<
  UserAccountEmailMutation,
  UserAccountEmailMutationVariables
>

export function useUserAccountEmailMutation(options?: Options) {
  return useMutation<
    UserAccountEmailMutation,
    UserAccountEmailMutationVariables
  >(mutation, options)
}
